import { render } from "./CommissionRule.vue?vue&type=template&id=968f7c56&scoped=true"
import script from "./CommissionRule.vue?vue&type=script&lang=js"
export * from "./CommissionRule.vue?vue&type=script&lang=js"

import "./CommissionRule.vue?vue&type=style&index=0&id=968f7c56&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-968f7c56"]])

export default __exports__